import previewApi from "../api/preview-api";

const savePreview = async (payload) => {
    const resp = await previewApi.savePreview(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const previewService = {
    savePreview
};

export default previewService;